import { OpenFormFetch } from './OpenFormFetch.js';
import { OpenFormFrame } from './OpenFormFrame.js';
import { type OpenFormActions, type OpenFormState } from './OpenFormReducer.js';
import { type OpenFormStore } from './OpenFormStore.js';
import type { OpenFormDraftItem } from '../../generated/api/openFormDraftItem.js';
import type { OpenFormListItem } from '../../generated/api/openFormListItem.js';
import type { RefObject } from 'react';

export class OpenFormAsync {
  static readonly cache = new Map<string, Promise<unknown>>();
  static readonly draft = new Map<string, OpenFormDraftItem>();
  static readonly fetch = OpenFormFetch(this);
  static readonly flags = new Set<'draft'>(['draft']);
  static readonly forms = new Map<string, OpenFormListItem>();
  static readonly zeroReasonCodes = new Map<string, string>();
  static readonly zeroPriceUrls = {
    elisaIntranetUrl: '',
    sfKnowledgeArticleUrl: '',
  };
  static readonly frame = OpenFormFrame(this);

  static actions: OpenFormActions;
  static store: OpenFormStore;
  static accountMasterId?: string;
  static #state: RefObject<OpenFormState>;

  static get state(): OpenFormState {
    return this.#state.current;
  }

  static set state(state: RefObject<OpenFormState>) {
    this.#state = state;
  }
}
